import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { login } from '../../redux/slices/authSlice';
import Background from '../../assets/images/bacgroundLG.jpg';
import Logo from '../../assets/images/logo-r.png';
import IconCall from '../../assets/images/call.png';
import IconEmail from '../../assets/images/email.png';
import IconFB from '../../assets/images/IconFB.png';
import IconInsta from '../../assets/images/in.png';
import IconZalo from '../../assets/images/Zalo.png';
import IconYTB from '../../assets/images/youtube.png';
import IcUser from '../../assets/images/ic-user.png';
import IcPass from '../../assets/images/ic-pass.png';
import { Form, Input, Checkbox, Button, message} from 'antd';
import { loginAsync, fetchSecretKey } from '../../redux/slices/authSlice';


const Login = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [form] = Form.useForm()
    const { loadingLogin, error } = useSelector(state => state.auth);

    useEffect(() => {
        const savedUsername = localStorage.getItem('savedUsername');
        const savedPassword = localStorage.getItem('savedPassword');
        if (savedUsername && savedPassword) {
            form.setFieldsValue({
                username: savedUsername,
                password: savedPassword,
                remember: true
            });
        }
    }, [form]);


    const onFinish = (val) => {
        form
            .validateFields()
            .then(async (values) => {
                handleLogin();
            })
            .catch((errorfields) => {

            });
    };

    const handleLogin = () => {
        const enteredUsername = form.getFieldValue('username');
        const enteredPassword = form.getFieldValue('password');
        const rememberMe = form.getFieldValue('remember');

        // Dispatch async thunk loginAsync để gọi API login
        dispatch(loginAsync({ username: enteredUsername, password: enteredPassword }))
            .unwrap()
            .then(() => {
                // Nếu login thành công, gọi fetchSecretKey
                dispatch(fetchSecretKey());

                // Lưu thông tin đăng nhập nếu chọn "remember me"
                if (rememberMe) {
                    localStorage.setItem('savedUsername', enteredUsername);
                    localStorage.setItem('savedPassword', enteredPassword);
                } else {
                    localStorage.removeItem('savedUsername');
                    localStorage.removeItem('savedPassword');
                }

                // Điều hướng sau khi đăng nhập thành công
                navigate('/dashboard');
            })
            .catch((error) => {
                message.error(error || "Tên đăng nhập hoặc mật khẩu không chính xác!");
            });
    };

    return (
        <>
            <div style={{
                backgroundImage: `url(${Background})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                height: '92vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '0px 0px'
            }}>
                <div style={{
                    display: 'flex',
                    width: '60%',
                    maxWidth: '850px',
                    background: 'white',
                    borderRadius: '10px',
                    padding: '40px 40px 40px 0px',
                    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                }}>
                    {/* Phần logo bên trái */}
                    <div style={{
                        flex: 1,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <img src={Logo} alt="Global Care Logo" style={{ width: '190px' }} />
                    </div>

                    <Form
                        onFinish={onFinish}
                        form={form}
                        layout="vertical"
                        requiredMark={false}
                        style={{
                            width: "450px", padding: "10px 30px 30px 30px", borderRadius: "20px",
                            background: "#f0f2f5", border: "0.5px solid #d2d2d2",
                            // boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                            gap: '2px', display: 'flex', flexDirection: 'column'
                        }}>
                        <div style={{
                            marginBottom: "15px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start" // Căn về bên trái
                        }}>
                            <h2 style={{
                                color: "#fb7800",
                                fontSize: "16px",
                                fontWeight: "600",
                                marginBottom: "5px"
                            }}>
                                Đăng nhập
                            </h2>
                            <hr style={{
                                width: "85px",
                                border: "2px solid #fb7800",
                                margin: "0" // Loại bỏ khoảng cách thừa
                            }} />
                        </div>

                        <Form.Item name="username" label="Tên đăng nhập" rules={[{ required: true, message: 'Vui lòng nhập thông tin!' }]}>
                            <Input
                                prefix={<img src={IcUser} width={20}/>}
                                style={{ width: "100%", padding: "10px 8px", borderRadius: "6px", fontSize: 14}}
                                placeholder="Nhập email"
                                size='large'
                            />
                        </Form.Item>

                        <Form.Item name="password" label="Mật khẩu" rules={[{ required: true, message: 'Vui lòng nhập thông tin!' }]}>
                            <Input.Password
                                prefix={<img src={IcPass} width={20}/>}
                                style={{ width: "100%", padding: "10px 8px", borderRadius: "6px", fontSize: 14}}
                                placeholder="Nhập mật khẩu"
                                size='large'
                            />
                        </Form.Item>
                        <Form.Item
                            name="rules"
                            rules={[
                                {
                                    required: true,
                                    message: "Vui lòng đồng ý chính sách!",
                                },
                            ]}
                        >
                            <Checkbox.Group
                                style={{ width: "100%" }}
                                onChange={(e) => {
                                }}
                            >
                                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 5 }}>
                                    <Checkbox value="rules">
                                    </Checkbox>
                                    <div style={{ color: "#343A40", fontWeight: 400 }}>
                                        Tôi đồng ý với{" "}
                                        <span
                                            onClick={() => {
                                                window.open("https://cdn.globalcare.vn/private/document/pdf/globalcare/2024-GC-CHINH-SACH-PHONG-CHONG-GIAN-LAN-THAM-NHUNG.pdf")
                                            }}
                                            style={{
                                                color: "#1048B9",
                                                cursor: 'pointer'
                                            }}
                                        >
                                            "Chính sách phòng chống gian lận và tham nhũng"
                                        </span>.
                                    </div>
                                </div>

                            </Checkbox.Group>
                        </Form.Item>

                        <Form.Item name="remember" valuePropName="checked">
                            <Checkbox style={{ color: "#1a427d", fontWeight: "400", fontSize: "14px" }}>
                                Nhớ đăng nhập
                            </Checkbox>
                        </Form.Item>

                        <Button
                            htmlType='submit'
                            // onClick={handleLogin}
                            loading={loadingLogin}
                            disabled={loadingLogin}
                            style={{
                                width: "100%", padding: "10px", background: loadingLogin ? "gray" : "orange",
                                color: "white", fontSize: "14px", border: "none",
                                borderRadius: "6px", cursor: loadingLogin ? "not-allowed" : "pointer",
                                height: 44
                            }}
                        >
                            Đăng nhập
                        </Button>
                    </Form>
                </div>
            </div >

            {/* Footer */}
            <div style={{
                height: '8vh',
                background: '#1A427D',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '0 20px',
                color: 'white',

            }}>
                <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                    <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <img src={IconCall} alt="" style={{ width: '18px', height: '18px' }} />
                        <a style={{textDecoration:'none', color:'#fff'}} href="tel:1900292987">1900 29 29 87</a>
                    </span>
                    <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <img src={IconEmail} alt="" style={{ width: '18px', height: '18px' }} />
                        <a style={{textDecoration:'none', color:'#fff'}} href="mailto:cskh@globalcare.vn">cskh@globalcare.vn</a>
                    </span>
                </div>

                <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
                    <a target='_blank' href="https://www.facebook.com/GlobalCare.vn"><img src={IconFB} alt="Facebook" style={{ width: '22px', height: '22px' }} /></a>
                    <a target='_blank' href="https://www.linkedin.com/company/global-care-company/"><img src={IconInsta} alt="Instagram" style={{ width: '22px', height: '22px' }} /></a>
                    <a target='_blank' href="https://zalo.me/1747508283619492630"><img src={IconZalo} alt="Zalo" style={{ width: '22px', height: '22px' }} /></a>
                    <a target='_blank' href="https://www.youtube.com/channel/UCVCpGwSPErtw3OyLQYwwulw"><img src={IconYTB} alt="YouTube" style={{ width: '22px', height: '22px' }} /></a>
                </div>
            </div>
        </>
    )
}
export default Login;